module.exports = __webpack_public_path__ + "assets/img/400.f5ad4f7b.png";